module.exports = __webpack_public_path__ + "static/NEW_COURSE-1bd2b14235faf5397caf9b3408788b4e.jpeg";